import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import posthog, { isExcludedPath } from "./posthog";

/**
 * Manual pageview, not capture_pageview:'history_change' — that would fire before the
 * impersonation handoff establishes identity. Must be rendered inside <BrowserRouter>.
 */
export default function usePageTracking() {
  const location = useLocation();
  const prev = useRef(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (prev.current === path) return;
    if (isExcludedPath(location.pathname)) return; // builder-widget routes
    try {
      posthog.capture("$pageview", {
        $current_url: window.location.href,
        path: location.pathname,
      });
    } catch (e) {
      // ignore
    }
    prev.current = path;
  }, [location]);
}
